import { CardSkeleton } from 'src/modules/shared/components/atoms/cards/card-skeleton';
import { TextSkeleton } from 'src/modules/shared/components/atoms/text/text-skeleton';

/**
 * Dashboard-level loading state for the reports panel.
 */
export const ReportsDashboardSkeleton: React.FC = () => (
  <div className="space-y-5 py-4">
    <div className="rounded-2xl border border-neutral-200 bg-white px-4 py-4 shadow-sm">
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <TextSkeleton className="h-4 w-64" />
        <div className="flex gap-2">
          <TextSkeleton className="h-9 w-28 rounded-lg" />
          <TextSkeleton className="h-9 w-24 rounded-lg" />
        </div>
      </div>
    </div>

    <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
      {Array.from({ length: 4 }).map((_, index) => (
        <CardSkeleton
          key={`report-dashboard-skeleton-${index}`}
          className="rounded-2xl border border-neutral-200 shadow-sm"
          header={{
            title: true,
            subtitle: true,
            action: true,
          }}
          content={{
            lines: 4,
            widths: ['w-5/6', 'w-full', 'w-3/4', 'w-2/3'],
          }}
        />
      ))}
    </div>
  </div>
);

/**
 * Widget-body loading state used inside one dashboard card.
 */
export const ReportWidgetBodySkeleton: React.FC = () => (
  <div className="space-y-3">
    <TextSkeleton className="h-4 w-32" />
    <TextSkeleton className="h-3 w-full" />
    <TextSkeleton className="h-3 w-5/6" />
    <TextSkeleton className="h-20 w-full rounded-xl" />
    <TextSkeleton className="h-3 w-2/3" />
  </div>
);
